export const MILESTONES = [
  {
    year: 2019,
    description: `We introduce Nigeria’s first ever commodities index – the AFEX Commodities Index (ACI) tracking the changes in price for three key agricultural commodities – maize, paddy rice and soybeans, 
    We continue our capital market integration in earnest introducing the first ever market education platform for commodities – EdEX.`,
  },
  {
    year: 2018,
    description: `We pilot the flagship #CodeCashCrop event, driving necessary conversation about the intersection of technology, finance and agriculture. 
    We also begin onboarding non-bank financial institutions on the Exchange for farmer financing.`,
  },
  {
    year: 2017,
    description: `Our trading platform powered by Nasdaq is launched, and is matched with a commencement in the distribution of our weekly commodities price data. 
    We launch our agribooster product in a partnership with OCP Africa, targeting 5000 farmers and also take part in the CBN ABP loan programme as an aggregator.`,
  },
  {
    year: 2016,
    description: `We launch the Grain Bank and Commodity Exchange project with West Africa Food Market (WAFM), targeting 100,000 farmers. 
    Also launched is the first structured Grain for Fertilizer Programme in Nigeria, and we issue a GBP350,000 repo bond that is fully subscribed to by DFID`,
  },
  {
    year: 2015,
    description: `We get licensed by the Security and Exchange Commission (SEC) to become the first private sector led commodities exchange in Nigeria`,
  },
  {
    year: 2014,
    description: `AFEX Commodities Exchange Limited (AFEX Nigeria) is established in Nigeria with an overarching outlook to develop a workable warehouse receipt system`,
  },
];
